export default __webpack_public_path__ + "static/media/whatsapp.2bcbc94b.svg";